// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JobPosition-module--wrapper--2CDiW","title":"JobPosition-module--title--37on4","button":"JobPosition-module--button--MveAU"};